import React, { useState } from 'react';
import { Root as Accordion } from '@radix-ui/react-accordion';
import { Tooltip, TooltipPosition } from 'components/tooltip';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { updatePuntataAllScommesse } from 'features/carrello/carrelloEditQuotaInput/actions';
import { CarrelloInputImporto } from 'features/carrello/carrelloInputImporto';
import {
  selectDefaultSistemaValue,
  selectPuntataAllScommesseByType,
  selectSistemiByType,
  selectTipo,
} from '../carrelloSelectors';
import { clearSelectedSistema } from 'features/carrello/carrelloSlice';
import styles from './CarrelloCombinazioni.module.scss';
import { CarrelloSistemiItem } from 'features/carrello/carrelloCombinazioni/components/carrelloCombinazioniItem';
import { isDivisible } from 'features/sport';

export const CarrelloCombinazioni = () => {
  const carrelloType = useTypedSelector(selectTipo);
  const sistemi = useTypedSelector((state) => selectSistemiByType(state, carrelloType));
  const [activeAccordions, setActiveAccordions] = useState<string[]>([]);
  const dispatch = useAppDispatch();
  const handleAccordionToggle = (id: string, isEnabled: boolean) => {
    setActiveAccordions((prev) => (isEnabled ? prev : prev.filter((item) => item !== id)));
  };
  const puntata = useTypedSelector((state) => selectPuntataAllScommesseByType(state, carrelloType));
  const defaultPuntata = useTypedSelector(selectDefaultSistemaValue);
  const [labelPuntaPerTutte, labelTooltipPuntaPerTutte] = useGetLabelsByKeys([
    'punta-per-tutte',
    'tooltip-punta-per-tutte',
  ]);
  return (
    <Accordion type="multiple" className={styles.root} value={activeAccordions} onValueChange={setActiveAccordions}>
      <div className={styles.puntaPerTutte}>
        <div className={styles.label}>{labelPuntaPerTutte}</div>
        <div className={styles.inputContainer}>
          <CarrelloInputImporto
            hasError={!!puntata && !isDivisible(+puntata)}
            puntata={puntata}
            setPuntataInputValue={(value) => {
              const newValue = typeof value === 'string' ? value : undefined;
              dispatch(updatePuntataAllScommesse(newValue!));
              dispatch(clearSelectedSistema());
            }}
            isDisabled={puntata === ''}
            onClick={() => {
              dispatch(clearSelectedSistema());
              if (puntata !== '') return;
              dispatch(updatePuntataAllScommesse(String(defaultPuntata)));
            }}
          />
          <Tooltip
            content={labelTooltipPuntaPerTutte}
            position={TooltipPosition.BOTTOM_LEFT}
            iconColor="--color-on-bg-secondary"
          />
        </div>
      </div>
      {sistemi?.map((sistema) => (
        <CarrelloSistemiItem id={sistema.id} key={sistema.id} handleAccordionToggle={handleAccordionToggle} />
      ))}
    </Accordion>
  );
};
